import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';

export const useDeleteGoodLocation = (declarantId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (locationId: string) => {
      return await request({
        path: `declarant/${declarantId}/good-location/${locationId}`,
        method: 'DELETE',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['good-locations', declarantId] });
      toast.success('Location of goods deleted successfully');
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || 'Failed to delete location of goods');
    },
  });
};
